import { render, staticRenderFns } from "./LicenseRow.vue?vue&type=template&id=2c7f1f00&scoped=true&"
import script from "./LicenseRow.vue?vue&type=script&lang=js&"
export * from "./LicenseRow.vue?vue&type=script&lang=js&"
import style0 from "./LicenseRow.vue?vue&type=style&index=0&id=2c7f1f00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7f1f00",
  null
  
)

export default component.exports